import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { ToastService } from '@utils/toast.service';
import { TableModule } from 'primeng/table';
import { InputGroup } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputMaskModule } from 'primeng/inputmask';
import { ImssService } from '@services/imss.service';
import { DialogModule } from 'primeng/dialog';
import { TagModule } from 'primeng/tag';
import { SatService } from '@services/sat.service';

@Component({
  selector: 'page-email',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    InputTextModule,
    SelectModule,
    TableModule,
    InputGroupAddonModule,
    InputGroup,
    IconFieldModule,
    InputIconModule,
    InputMaskModule,
    DialogModule,
    TagModule,
  ],
  templateUrl: './email.component.html',
  styleUrl: './email.component.scss',
})
export class EmailComponent {
  private formBuilder = inject(FormBuilder);
  private satService = inject(SatService);
  private toastService = inject(ToastService);

  public isSaving = false;
  public statusModalDetails = false;
  public statusModalError = false;

  public formUpload = this.formBuilder.group({
    rfc: [null, Validators.required],
    email: [null, [Validators.required, Validators.email]],
  });

  public list: any[] = [];
  public itemError: any = [];
  public searchValue: string | undefined;

  ngOnInit() {
    this.refresh();
  }

  refresh = async () => {
    await this.satService.listRestablecerContrasena('internal').then((response) => (this.list = response));
  };

  get curp() {
    return this.formUpload.get('curp');
  }
  set curp(value: any) {
    this.curp.setValue(value);
  }

  get email() {
    return this.formUpload.get('email');
  }
  set email(value: any) {
    this.email.setValue(value);
  }

  consult = async () => {
    this.isSaving = true;

    this.satService
      .restablecerContrasena(this.formUpload.value)
      .then(() => {
        this.toastService.success('Se ha enviado un correo electrónico para restablecer la contraseña.');
        this.formUpload.reset();
        this.refresh();
      })
      .catch((err) => {
        this.toastService.error(err.error.data.message || 'Error.');
      })
      .finally(() => (this.isSaving = false));
  };

  showError = (error: string) => {
    this.statusModalError = true;
    this.itemError = error;
  };
}
